import "./styles.css";
import stateController from "./uiHandlers/stateController";

stateController.init();
